import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import arrow_left2 from "../../../assets/images/arrow_left2.svg";
import arrow_right2 from "../../../assets/images/arrow_right2.svg";
import bg_member from "../../../assets/images/bg_member.jpg";
import member01 from "../../../assets/images/member01.webp";
import member02 from "../../../assets/images/member02.webp";
import member03 from "../../../assets/images/member03.webp";
import member04 from "../../../assets/images/member04.webp";
import member05 from "../../../assets/images/member05.webp";
import member06 from "../../../assets/images/member06.webp";
import member_pci from "../../../assets/images/member_pci.jpg";
import anh01_on from "../../../assets/images/anh01_on.webp";
import anh01_off from "../../../assets/images/anh01_off.webp";
import anh02_on from "../../../assets/images/anh02_on.webp";
import anh02_off from "../../../assets/images/anh02_off.webp";
import anh03_on from "../../../assets/images/anh03_on.webp";
import anh03_off from "../../../assets/images/anh03_off.webp";
import anh04_on from "../../../assets/images/anh04_on.webp";
import anh04_off from "../../../assets/images/anh04_off.webp";
import anh05_off from "../../../assets/images/anh05_off.webp";
import anh05_on from "../../../assets/images/anh05_on.webp";
import anh06_on from "../../../assets/images/anh06_on.webp";
import anh06_off from "../../../assets/images/anh06_off.webp";

export default function MemberSlide() {
  const swiperRef = useRef(null);

  const profiles = [
    {
      name: "Trần Anh Tuấn",
      position: "Chủ tịch, CEO & Founder",
      image: member01,
      avaOn: anh01_on,
      avaOff: anh01_off,
      description:
        "Với 30 năm kinh nghiệm trong lĩnh vực kinh doanh và gần 20 năm trong công nghệ thông tin, ông Trần Anh Tuấn đã xây dựng nền móng vững chắc cho sự phát triển của công ty. Dưới sự lãnh đạo của ông, công ty đã không ngừng đổi mới và mở rộng các giải pháp công nghệ nhằm đáp ứng nhu cầu ngày càng cao của thị trường",
    },
    {
      name: "Trần Văn Bạch",
      position: "Phó tổng giám đốc, Co-Founder",
      image: member02,
      avaOn: anh02_on,
      avaOff: anh02_off,
      description:
        "Chuyên gia đầu ngành với hơn 30 năm kinh nghiệm trong lĩnh vực công nghệ thông tin. Ông đã tham gia thiết kế và triển khai hơn 100 hệ thống công nghệ cho các doanh nghiệp quy mô lớn, giúp tối ưu hóa hoạt động và quản lý hiệu quả",
    },
    {
      name: "Ngô Hoàng Sơn",
      position: "Giám đốc Kĩ thuật, Co-Founder",
      image: member03,
      avaOn: anh03_on,
      avaOff: anh03_off,
      description:
        "Với hơn 10 năm kinh nghiệm trong vai trò lập trình viên và quản lý dự án, đặc biệt là quản lý đội nhóm lớn lên đến 30 người. Sự am hiểu sâu về phát triển phần mềm và quản trị đội nhóm của ông đã góp phần vào thành công của nhiều dự án lớn",
    },
    {
      name: "Phạm Anh Tuấn",
      position: "Giám đốc Kĩ thuật, Co-Founder",
      image: member04,
      avaOn: anh04_on,
      avaOff: anh04_off,
      description:
        "Với hơn 10 năm kinh nghiệm trong lập trình và xử lý dữ liệu, ông Phạm Anh Tuấn đảm nhận vai trò quan trọng trong việc xây dựng và tối ưu hóa các hệ thống quản lý cơ sở dữ liệu phức tạp, đảm bảo tính bảo mật và hiệu quả cho các dự án.",
    },
    {
      name: "Trần Văn Chiến",
      position: "Chuyên viên IT Support",
      image: member05,
      avaOn: anh05_on,
      avaOff: anh05_off,
      description:
        "Với 8 năm kinh nghiệm trong việc quản lý hệ thống công nghệ thông tin cho các doanh nghiệp vừa và nhỏ. Ông là người đảm bảo các hệ thống công ty luôn vận hành ổn định và hiệu quả, đồng thời hỗ trợ kỹ thuật nhanh chóng khi có sự cố.",
    },
    {
      name: "Bùi Hữu Hoài",
      position: "Chuyên viên IT HelpDesk",
      image: member06,
      avaOn: anh06_on,
      avaOff: anh06_off,
      description:
        " Với hơn 8 năm kinh nghiệm trong hỗ trợ khách hàng về IT, ông Bùi Hữu Hoài là đầu mối quan trọng trong việc tư vấn và giải quyết các vấn đề kỹ thuật cho khách hàng, đảm bảo hệ thống luôn hoạt động suôn sẻ và đáp ứng kịp thời nhu cầu của người dùng.",
    },
  ];

  const [currentProfile, setCurrentProfile] = useState(profiles[0]);

  return (
    <div className="w-full">
      <div className="container block md:hidden lg:hidden">
        <Swiper
          ref={swiperRef}
          modules={[Navigation]}
          loop={true}
          navigation={false}
          className="swiper-container"
        >
          {profiles.map((profile, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative bg-cover bg-center bg-no-repeat w-full"
                style={{ backgroundImage: `url(${bg_member})` }}
              >
                <div className="flex flex-col items-center w-full">
                  <div className="relative">
                    <img
                      className="w-64 h-auto bottom-[-16px] mb-4 object-cover relative z-10"
                      src={profile.image}
                      alt={profile.name}
                    />
                  </div>
                  <div className="px-[16px] py-[16px] flex flex-col items-center gap-3 h-[358px] bg-white shadow-md w-full rounded-t-[16px] backdrop-blur-[16px]">
                    <h2 className="text-lg font-bold text-blue-600">
                      {profile.name}
                    </h2>
                    <h3 className="text-md text-blue-800 font-semibold">
                      {profile.position}
                    </h3>
                    <p className="text-gray-600 mt-4 w-[358px] text-start h-full">
                      {profile.description}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex justify-center mt-4">
          <button
            className="bg-gray-100 p-2 rounded-full shadow-md"
            onClick={() => swiperRef.current.swiper.slidePrev()}
            aria-label="Previous member profile"
          >
            <img src={arrow_left2} alt="Left arrow" />
          </button>

          <button
            className="bg-gray-100 p-2 rounded-full shadow-md ml-2"
            onClick={() => swiperRef.current.swiper.slideNext()}
            aria-label="Next member profile"
          >
            <img src={arrow_right2} alt="Right arrow" />
          </button>
        </div>
      </div>

      <div
        className="w-full hidden md:block lg:block bg-center bg-cover bg-no-repeat h-auto relative"
        style={{ backgroundImage: `url(${member_pci})` }}
      >
        <div className="container p-3 mx-auto flex flex-col w-full">
          <div className="flex flex-row items-center justify-between w-full">
            <div>
              <button
                className="bg-gray-100 p-2 rounded-full shadow-md"
                onClick={() => swiperRef.current.swiper.slidePrev()}
                aria-label="Previous member profile"
              >
                <img src={arrow_left2} alt="Left arrow" />
              </button>
            </div>

            <Swiper
              ref={swiperRef}
              modules={[Navigation]}
              loop={true}
              navigation={false}
              className="swiper-container lg:max-w-[582px] lg:max-h-[482px]"
              onSlideChange={(swiper) =>
                setCurrentProfile(profiles[swiper.realIndex])
              }
            >
              {profiles.map((profile, index) => (
                <SwiperSlide key={index}>
                  <div className="w-[582px] h-[482px] bg-blue-sky-gradient7 shadow backdrop-blur-custom-blur rounded-[20px] px-[24px] py-[80px] flex flex-col gap-3">
                    <div>
                      <p className="text-[64px] font-semibold text-[#1C9BDB]">
                        {profile.name}
                      </p>
                    </div>
                    <div>
                      <p className="text-[24px] font-semibold text-[#033F6A]">
                        {profile.position}
                      </p>
                    </div>
                    <div>
                      <p className="text-[16px] font-normal text-[#333]">
                        {profile.description}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div>
              <img
                src={currentProfile.image}
                alt={currentProfile.name}
                className="relative bottom-[-12px] object-cover w-full h-[50rem] md:block"
              />
            </div>

            <div>
              <button
                className="bg-gray-100 p-2 rounded-full shadow-md ml-2"
                onClick={() => swiperRef.current.swiper.slideNext()}
                aria-label="Next member profile"
              >
                <img src={arrow_right2} alt="Right arrow" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-white hidden md:block lg:block" id="meo">
        <div className="container mx-auto p-3 grid grid-cols-6 gap-20 ">
          {profiles.map((profile, index) => (
            <div
              key={index}
              className="flex flex-col text-center items-center justify-center"
            >
              <img
                src={
                  profile.image === currentProfile.image
                    ? profile.avaOn
                    : profile.avaOff
                }
                alt={profile.name}
                className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="font-semibold text-[#033F6A] text-[18px] h-[50px]">
                {profile.name}
              </h3>
              <p className="text-[16px] text-[#919191] font-normal text-center w-[170px] h-[100px]">
                {profile.position}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
